import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PROJECT_MANAGEMENT_URL } from '@insite-store360/shared';
import { Observable, catchError } from 'rxjs';
import { ErrorHandlerService } from './error-handler.service';

export interface QuotationSetupItem {
    id?: number;
    countryId: number;
    countryName?: string;
    quotationTitle?: string;
    projectLabel?: string;
    noLabel?: string;
    descriptionLabel?: string;
    imageLabel?: string;
    modelLabel?: string;
    quantityLabel?: string;
    rateUnitLabel?: string;
    amountWithVatLabel?: string;
    vatPercentageLabel?: string;
    vatAmountLabel?: string;
    totalWithVatLabel?: string;
    termsConditionsLabel?: string;
    pncLabel?: string;
    installationLabel?: string;
    priceLabel?: string;
    offerPriceLabel?: string;
    totalLabel?: string;
    toLabel?: string;
    fromLabel?: string;
    createdAt?: Date;
    updatedAt?: Date;
}

@Injectable({
    providedIn: 'root',
})
export class QuotationSetupService {
    private readonly URL_PATH = `${PROJECT_MANAGEMENT_URL}/quotation-setup`;

    constructor(
        private http: HttpClient,
        private errorHandler: ErrorHandlerService
    ) { }

    public getByCountryId(countryId: number): Observable<QuotationSetupItem | null> {
        return this.http
            .get<QuotationSetupItem | null>(`${this.URL_PATH}/getByCountryId/${countryId}`)
            .pipe(catchError(this.errorHandler.handleError));
    }

    public getAll(
        pageIndex?: number,
        pageSize?: number,
        searchValue?: string,
        countryIds?: number | number[]
    ): Observable<{ data: QuotationSetupItem[]; paginatorValue: { totalData: number; totalCount: number } }> {
        let params = new HttpParams();
        if (pageIndex !== undefined && pageIndex !== null) {
            params = params.set('pageIndex', (pageIndex + 1).toString());
        }
        if (pageSize !== undefined && pageSize !== null) {
            params = params.set('pageSize', pageSize.toString());
        }
        if (searchValue && searchValue.trim() !== '') {
            params = params.set('searchValue', searchValue.trim());
        }
        if (countryIds) {
            params = params.set('countryIds', Array.isArray(countryIds) ? countryIds.join(',') : countryIds.toString());
        }
        return this.http
            .get<{ data: QuotationSetupItem[]; paginatorValue: { totalData: number; totalCount: number } }>(`${this.URL_PATH}/getAll`, { params })
            .pipe(catchError(this.errorHandler.handleError));
    }

    public save(dto: QuotationSetupItem): Observable<{ message: string; result: QuotationSetupItem }> {
        return this.http
            .post<{ message: string; result: QuotationSetupItem }>(`${this.URL_PATH}/save`, dto)
            .pipe(catchError(this.errorHandler.handleError));
    }
}
